import { PublicClientApplication, LogLevel } from '@azure/msal-browser';

export const msalConfig = {
  auth: {
    clientId: 'db8d2095-ea76-4e60-a481-d8a7619a9cc9',
    authority: 'https://login.microsoftonline.com/e229788c-b41f-4ace-bd37-bf7ba2192586',
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            //console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

export const loginRequest = {
  scopes: ['https://gwii.com/e243f129-4e0b-4537-ace6-2a0bf0cd7e0c/webread'],
};

export const msalInstance = new PublicClientApplication(msalConfig);
